import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
   Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Container,
  Card,
  Typography,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Grid,
  Tooltip,
  TablePagination,
  Box,
  CircularProgress,
    Snackbar,
    Alert
} from "@mui/material";
import {
  Edit as EditIcon,
  Search as SearchIcon,
  Download as DownloadIcon,
  Block as BlockIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import * as XLSX from "xlsx";
import BASE_URL from "../config";
import { Link } from "react-router-dom";
const StudentsPage = () => {
  const [courses, setCourses] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [page, setPage] = useState(0);
  /* const [rowsPerPage, setRowsPerPage] = useState(5); */
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedStudents, setSelectedStudents] = useState([]);
const [feesCategories, setFeesCategories] = useState([]);
const [selectedCategory, setSelectedCategory] = useState("");
const [routes, setRoutes] = useState([]);
const [selectedRoute, setSelectedRoute] = useState("");
const [sections, setSections] = useState([]);
const [selectedSection, setSelectedSection] = useState("");
const [rollParentOpen, setRollParentOpen] = useState(false);
const [rollParentStudents, setRollParentStudents] = useState([]);
const [loadingRollParent, setLoadingRollParent] = useState(false);
const [savingRollParent, setSavingRollParent] = useState(false);
const [rollParentSearch, setRollParentSearch] = useState("");
const [snack, setSnack] = useState({
  open: false,
  message: "",
  severity: "success",
});
  const navigate = useNavigate();
  useEffect(() => {
    fetchCourses();
  }, []);
  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/coursesa`);
      setCourses(res.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };
  const fetchAcademicYears = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/academicYears/${courseID}`);
      setAcademicYears(res.data);
    } catch (error) {
      console.error("Error fetching academic years:", error);
    }
  };
  const fetchClasses = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/classes?course=${courseID}`);
      setClasses(res.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const fetchStudents = async () => {
     if (!selectedCourse || !selectedYear) {
    alert("Please select both Course and Academic Year.");
    return;
  }
    try {
      const params = {};
      if (selectedCourse) params.courseID = selectedCourse;
      if (selectedYear) params.academicYear = selectedYear;
      if (selectedClass) params.classID = selectedClass;
      if (selectedSection) params.sectionID = selectedSection;
      if (searchName) params.studentName = searchName;
      const res = await axios.get(`${BASE_URL}/api/getStudents`, { params });
      setStudents(res.data);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };
  const handleCourseChange = (courseID) => {
    setSelectedCourse(courseID);
    setSelectedYear("");
    setSelectedClass("");
    if (courseID) {
      fetchAcademicYears(courseID);
      fetchClasses(courseID);
    } else {
      setAcademicYears([]);
      setClasses([]);
    }
  };
  const handleClassChange = async (classID) => {
  setSelectedClass(classID);
  setSelectedSection(""); // reset section when class changes
  if (classID) {
    try {
      const res = await axios.get(`${BASE_URL}/api/sections/${classID}`);
      if (res.data && res.data.length > 0) {
        setSections(res.data);
      } else {
        setSections([]); // no sections available
      }
    } catch (err) {
      console.error("Error fetching sections:", err);
    }
  } else {
    setSections([]);
  }
};
  const handleEdit = (studentID) => {
    navigate(`/edit-student/${studentID}`);
  };
  const handleToggleStatus = async (studentID, isActive) => {
    const newStatus = isActive ? 0 : 1;
    if (window.confirm(`Are you sure you want to mark this student as ${newStatus ? "Active" : "Inactive"}?`)) {
      try {
        await axios.put(`${BASE_URL}/api/toggleStudentStatus/${studentID}`, { isActive: newStatus });
        alert(`Student marked as ${newStatus ? "Active" : "Inactive"} successfully`);
        fetchStudents();
      } catch (error) {
        alert("Error updating student status");
        console.error("Error:", error);
      }
    }
  };
  const handleExportToExcel = () => {
    if (students.length === 0) {
      alert("There are no records to export.");
      return;
    }
    const exportData = students.map(
      ({ StudentID,StudentName, ParentName, CourseName, AcademicYearName, ClassName,SectionName,MobileNumber }) => ({
        "Student ID": StudentID,
        "Student Name": StudentName,
        "Parent Name": ParentName,
        "Course": CourseName,
        "Academic Year": AcademicYearName,
        "Class": ClassName,
        "Section":SectionName,
        "Mobile":MobileNumber,
      })
    );
    // Create worksheet from student data
    const worksheet = XLSX.utils.json_to_sheet(exportData,{ origin: "A3" }); // Start from row 3
     //Add society and college names manually at the top
  XLSX.utils.sheet_add_aoa(worksheet, [
  ["Trust(R)"], // Row 1
   ["SMC Jain School-Shahapur"],   // Row 2
  ], { origin: "A1" });
  // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");
    // Export the file
    XLSX.writeFile(workbook, "Students.xlsx");
  };
  const fetchFeesCategories = async () => {
  try {
     if (!selectedCourse) {
      alert("Please select a Course to fetch fee categories.");
      return;
    }
    //const res = await axios.get(`${BASE_URL}/api/feesCategories?type=0`);
    const res = await axios.get(`${BASE_URL}/api/getNonRegularFeeCategoriess`, {
      params: { courseID: selectedCourse },
    });
    setFeesCategories(res.data);
  } catch (error) {
    console.error("Error fetching fees categories:", error);
  }
};
const handleSelectAll = (event) => {
  if (event.target.checked) {
    const allIds = students.map((s) => s.StudentID);
    setSelectedStudents(allIds);
    fetchFeesCategories();
  } else {
    setSelectedStudents([]);
    setSelectedCategory("");
  }
};
const handleSelectStudent = (studentID) => {
  let updatedSelection = [...selectedStudents];
  if (updatedSelection.includes(studentID)) {
    updatedSelection = updatedSelection.filter((id) => id !== studentID);
  } else {
    updatedSelection.push(studentID);
  }
  setSelectedStudents(updatedSelection);
  if (updatedSelection.length > 0) fetchFeesCategories();
  else {
    setSelectedCategory("");
  }
};
const handleUpdateCategory = async () => {
  if (selectedStudents.length === 0) {
    alert("Please select at least one student.");
    return;
  }
  if (!selectedCategory) {
    alert("Please select a category.");
    return;
  }
  if (routes.length > 0 && !selectedRoute) {
    alert("Please select a route fee.");
    return;
  }
  try {
    const res = await axios.post(`${BASE_URL}/api/checkExistingFees`, {
      studentIDs: selectedStudents,
      categoryID: selectedCategory,
    });
    const { exists, alreadyAssigned, unassignedIDs, message } = res.data;
    if (exists) {
      alert(message); // Inform about already assigned students
    }
    if (unassignedIDs && unassignedIDs.length > 0) {
      await axios.post(`${BASE_URL}/api/updateStudentFeesCategory`, {
        studentIDs: unassignedIDs,
        categoryID: selectedCategory,
        routeID: selectedRoute,
        adminName: sessionStorage.getItem("adminName"),
      });
      alert("Fees category updated for unassigned students.");
      setSelectedStudents([]);
      setSelectedCategory("");
      fetchStudents();
    } else if (!exists) {
      alert("All selected students already have the category assigned.");
    }
  } catch (error) {
    console.error("Error updating category:", error);
    alert("Failed to update category.");
  }
};
const handleCategoryChange = async (categoryID) => {
  setSelectedCategory(categoryID);
  setSelectedRoute(""); // Clear previous route selection
  if (categoryID) {
    try {
      const res = await axios.get(`${BASE_URL}/api/getRouteDetails/${categoryID}`);
      setRoutes(res.data);
    } catch (err) {
      console.error("Error fetching route details:", err);
    }
  } else {
    setRoutes([]);
  }
};
const handleDeleteStudents = async () => {
  if (selectedStudents.length === 0) {
    alert("Please select at least one student.");
    return;
  }
  const confirm = window.confirm(
    `Are you sure you want to delete ${selectedStudents.length} selected student(s)? This action cannot be undone.`
  );
  if (!confirm) return;
  try {
    const response = await axios.post(`${BASE_URL}/api/deleteStudents`, {
      studentIDs: selectedStudents,
      deletedBy : sessionStorage.getItem("adminName"),
    });
    alert(response.data.message || "Deleted successfully.");
    // Refresh students list
    fetchStudents();
    setSelectedStudents([]);
    setSelectedCategory("");
  } catch (err) {
    console.error("Delete Error:", err);
    alert("Failed to delete students.");
  }
};
const handleUpdateSection = async () => {
  try {
    const payload = {
      studentIDs: selectedStudents,
      courseID: selectedCourse,
      academicYearID: selectedYear,
      classID: selectedClass,
      sectionID: selectedSection
    };
    const res = await axios.post(`${BASE_URL}/api/checkAssignedSection`, payload);
    let assignedIDs = [];
    let assignedMessages = [];
    if (res.data.exists && res.data.conflicts.length > 0) {
      assignedIDs = res.data.conflicts.map((c) => c.StudentID);
      assignedMessages = res.data.conflicts.map(
        (c) =>
          `Already assigned ${c.SectionName} of ${c.ClassName} for ${c.StudentName}`
      );
    }
    const unassignedIDs = selectedStudents.filter(
      (id) => !assignedIDs.includes(id)
    );
    if (assignedMessages.length > 0) {
      alert(assignedMessages.join(", "));
    }
    if (unassignedIDs.length === 0) {
      return; // All were already assigned
    }
    // Proceed to update unassigned students only
    const updatePayload = {
      ...payload,
      studentIDs: unassignedIDs,
    };
    const updateRes = await axios.post(`${BASE_URL}/api/updateStudentSection`, updatePayload);
    if (updateRes.data.success) {
      alert("Section successfully assigned to remaining unassigned students.");
      fetchStudents(); // Refresh table
      setSelectedStudents([]); // Optional: reset selection
    } else {
      alert("Failed to update section.");
    }
  } catch (err) {
    console.error("Section update error:", err);
    alert("An error occurred. Please try again.");
  }
};
const handleOpenRollParent = async () => {
    if(!selectedCourse){
        alert("Please select Course");
        return;
    }
    if(!selectedYear){
        alert("Please select Academic Year");
        return;
    }
    if(!selectedClass){
        alert("Please select Class");
        return;
    }
    setLoadingRollParent(true);
    setRollParentOpen(true);
    try{
        const res=await axios.get(
            `${BASE_URL}/api/getRollParentStudents`,
            {
                params:{
                    CourseID:selectedCourse,
                    AcademicYearID:selectedYear,
                    ClassID:selectedClass,
                    SectionID:selectedSection || 0
                }
            }
        );
        setRollParentStudents(res.data);

    }
    catch(err){
        console.log(err);
        alert("Unable to fetch students.");

    }
    finally{
        setLoadingRollParent(false);
    }
};
const handleCloseRollParent=()=>{
    setRollParentOpen(false);
    setRollParentStudents([]);
    setRollParentSearch("");
};
const handleRollChange=(studentID,value)=>{
    setRollParentStudents(prev=>
        prev.map(student=>
            student.StudentID===studentID
            ?
            {
                ...student,
                RollNumber:value
            }
            :
            student
        )
    );
};
const handleParentChange=(studentID,value)=>{
  setRollParentStudents(prev=>
        prev.map(student=>
            student.StudentID===studentID
            ?
            {
                ...student,
                ParentName:value
            }
            :
            student
        )
    );
};
const filteredRollStudents=rollParentStudents.filter(student=>{
    const search=rollParentSearch.toLowerCase();
    return(
        student.StudentName.toLowerCase().includes(search)
        ||
        String(student.RollNumber || "").includes(search)
    );
});
const handleSaveRollParent=async()=>{
const rollNos = rollParentStudents
    .map(s => String(s.RollNumber || "").trim())
    .filter(r => r !== "");

const duplicates = rollNos.filter(
    (r, i) => rollNos.indexOf(r) !== i
);
if (duplicates.length > 0) {
    setSnack({
        open: true,
        severity: "error",
        message:
            "Duplicate Roll Numbers found in the list."
    });
    return;
}
    setSavingRollParent(true);
    try{
        await axios.post(
            `${BASE_URL}/api/saveRollParent`,
            {
                CourseID:selectedCourse,
                AcademicYearID:selectedYear,
                ClassID:selectedClass,
                SectionID:selectedSection || 0,
                Students:rollParentStudents
            }
        );
        setSnack({
            open:true,
            severity:"success",
            message:"Updated Successfully"
        });
        handleCloseRollParent();
        fetchStudents();
    }

/*     catch(err){

        console.log(err);

        setSnack({

            open:true,

            severity:"error",

            message:err.response?.data?.message || "Update Failed"

        });

    } */
catch (err) {

    console.log("Error:", err);

    console.log("Response:", err.response);

    console.log("Response Data:", err.response?.data);

    setSnack({
        open: true,
        severity: "error",
        message: err.response?.data?.message || JSON.stringify(err.response?.data) || err.message
    });

}
    finally{

        setSavingRollParent(false);

    }

};

const handleParentContactChange = (studentId, value) => {

    setRollParentStudents(prev =>
        prev.map(s =>
            s.StudentID === studentId
                ? {
                    ...s,
                    ParentContact: value
                  }
                : s
        )
    );

};
  return (

    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Card sx={{ p: 4, boxShadow: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Manage Students
        </Typography> 
        {/* Filters */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Course"
              value={selectedCourse || ""}
              onChange={(e) => handleCourseChange(e.target.value)}
            >
              <MenuItem value="">-- Select Course --</MenuItem>
              {courses.length > 0 ? (
                courses.map((course) => (
                  <MenuItem key={course.CourseID} value={course.CourseID}>
                    {course.CourseName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No courses available</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Academic Year"
              value={selectedYear || ""}
              onChange={(e) => setSelectedYear(e.target.value)}
              disabled={!selectedCourse || academicYears.length === 0}
            >
              <MenuItem value="">-- Select Academic Year --</MenuItem>
              {academicYears.length > 0 ? (
                academicYears.map((year) => (
                  <MenuItem key={year.AcademicYearID} value={year.AcademicYearID}>
                    {year.AcademicYearName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No academic years available</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Class"
              value={selectedClass || ""}
              /* onChange={(e) => setSelectedClass(e.target.value)} */
               onChange={(e) => handleClassChange(e.target.value)}
              disabled={!selectedCourse || classes.length === 0}
            >
              <MenuItem value="">-- Select Class --</MenuItem>
              {classes.length > 0 ? (
                classes.map((cls) => (
                  <MenuItem key={cls.id || cls.ClassID} value={cls.id || cls.ClassID}>
                    {cls.name || cls.ClassName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No classes available</MenuItem>
              )}
            </TextField>
          </Grid>
          {sections.length > 0 && (
  <Grid item xs={12} sm={4}>
    <TextField
      select
      fullWidth
      label="Select Section"
      value={selectedSection || ""}
      onChange={(e) => setSelectedSection(e.target.value)}
    >
      <MenuItem value="">-- Select Section --</MenuItem>
      {sections.map((sec) => (
        <MenuItem key={sec.SectionID} value={sec.SectionID}>
          {sec.SectionName}
        </MenuItem>
      ))}
    </TextField>
  </Grid>
)}

{selectedSection && selectedStudents.length > 0 && (
  <Button
    variant="contained"
    color="primary"
    onClick={handleUpdateSection}
    sx={{ mt: 2 }}
  >
    Update Section
  </Button>
)}

          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Search Student Name/ID"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={fetchStudents}
              startIcon={<SearchIcon />}
            >
              Search
            </Button>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              fullWidth
              variant="contained"
              color="success"
              onClick={handleExportToExcel}
              startIcon={<DownloadIcon />}
            >
              Export to Excel
            </Button>
          </Grid>

<Grid item xs={12} sm={4}>

<Button

fullWidth

variant="contained"

color="secondary"

disabled={students.length===0}

onClick={handleOpenRollParent}

sx={{

height:55,

fontWeight:"bold",

borderRadius:"10px",

textTransform:"none"

}}

>

Update Roll Number / Parent Name

</Button>

</Grid>



{/* ===========================================================
      UPDATE ROLL NUMBER / PARENT NAME DIALOG
=========================================================== */}

<Dialog
    open={rollParentOpen}
    onClose={handleCloseRollParent}
    fullWidth
    maxWidth="lg"
    PaperProps={{
        sx: {
            borderRadius: 3,
            overflow: "hidden",
            minHeight: "80vh"
        }
    }}
>

<DialogTitle
    sx={{
        background: "linear-gradient(90deg,#1565C0,#42A5F5)",
        color: "#fff",
        fontWeight: "bold",
        fontSize: 22,
        textAlign: "center",
        letterSpacing: 1
    }}
>

    Update Roll Number & Parent Name

</DialogTitle>

<DialogContent
    sx={{
        mt:2,
        p:3
    }}
>

<Grid container spacing={2} alignItems="center">

<Grid item xs={12} md={8}>

<TextField
    fullWidth
    label="Search Student Name / Roll Number"
    value={rollParentSearch}
    onChange={(e)=>setRollParentSearch(e.target.value)}
/>

</Grid>

<Grid item xs={12} md={4}>

<Typography
    sx={{
        fontWeight:"bold",
        color:"#1565C0",
        fontSize:16
    }}
>

Students : {filteredRollStudents.length}

</Typography>

</Grid>

</Grid>

{
loadingRollParent ?

<Box
sx={{
display:"flex",
justifyContent:"center",
alignItems:"center",
height:350
}}
>

<CircularProgress size={50}/>

</Box>

:

<TableContainer

component={Paper}

sx={{

mt:3,

maxHeight:"60vh",

border:"1px solid #ddd",

borderRadius:2,

boxShadow:4

}}

>

<Table stickyHeader>

<TableHead>

<TableRow>

<TableCell

align="center"

sx={{

background:"#1976d2",

color:"#fff",

fontWeight:"bold",

minWidth:120,

fontSize:15

}}

>

Roll Number

</TableCell>

<TableCell

align="center"

sx={{

background:"#1976d2",

color:"#fff",

fontWeight:"bold",

minWidth:250,

fontSize:15

}}

>

Parent Name

</TableCell>

<TableCell
    sx={{
        background: "#1976d2",
        color: "#fff",
        fontWeight: "bold",
        minWidth: 180
    }}
>
    Parent Contact
</TableCell>



<TableCell

sx={{

background:"#1976d2",

color:"#fff",

fontWeight:"bold",

minWidth:250,

fontSize:15

}}

>

Student Name

</TableCell>

{/* <TableCell

align="center"

sx={{

background:"#1976d2",

color:"#fff",

fontWeight:"bold",

minWidth:120,

fontSize:15

}}

>

Gender

</TableCell> */}

<TableCell

align="center"

sx={{

background:"#1976d2",

color:"#fff",

fontWeight:"bold",

minWidth:140,

fontSize:15

}}

>

Mobile

</TableCell>

</TableRow>

</TableHead>

<TableBody>
  {filteredRollStudents.length > 0 ? (
  filteredRollStudents.map((student, index) => (
    <TableRow
      key={student.StudentID}
      hover
      sx={{
        backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
        "&:hover": {
          backgroundColor: "#E3F2FD"
        }
      }}
    >
      {/* Roll Number */}

      <TableCell align="center">
        <TextField
          value={student.RollNumber || ""}
          onChange={(e) =>
            handleRollChange(student.StudentID, e.target.value)
          }
          size="small"
          fullWidth
          inputProps={{
            maxLength: 6,
            style: {
              textAlign: "center",
              fontWeight: "bold"
            }
          }}
        />
      </TableCell>

      {/* Parent Name */}

      <TableCell>
        <TextField
          value={student.ParentName || ""}
          onChange={(e) =>
            handleParentChange(student.StudentID, e.target.value)
          }
          size="small"
          fullWidth
          inputProps={{
            maxLength: 100
          }}
        />
      </TableCell>
 {/* Parent Contact */}
<TableCell>

<TextField
    fullWidth
    size="small"
    value={student.ParentContact || ""}
    onChange={(e)=>handleParentContactChange(
        student.StudentID,
        e.target.value
    )}
/>

</TableCell>


      {/* Student Name */}

      <TableCell>

        <Typography
          sx={{
            fontWeight: 600,
            color: "#0D47A1"
          }}
        >
          {student.StudentName}
        </Typography>

      </TableCell>

      {/* Gender */}

      {/* <TableCell align="center">

        <Typography>

          {student.Gender || "-"}

        </Typography>

      </TableCell> */}

      {/* Mobile */}

      <TableCell align="center">

        <Typography>

          {student.MobileNumber || "-"}

        </Typography>

      </TableCell>

    </TableRow>
  ))
) : (
  <TableRow>
    <TableCell
      colSpan={5}
      align="center"
      sx={{
        color: "red",
        fontWeight: "bold",
        py: 4
      }}
    >
      No Students Found
    </TableCell>
  </TableRow>
)}

</TableBody>

</Table>

</TableContainer>

}

</DialogContent>
<DialogActions
    sx={{
        p: 2,
        backgroundColor: "#f5f5f5",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2
    }}
>

<Typography
    variant="body2"
    sx={{
        color: "#1565C0",
        fontWeight: "bold",
        alignSelf: "center"
    }}
>
    Total Students : {filteredRollStudents.length}
</Typography>

<Box
    sx={{
        display: "flex",
        gap: 2,
        flexWrap: "wrap"
    }}
>

<Button
    variant="outlined"
    color="error"
    onClick={handleCloseRollParent}
    disabled={savingRollParent}
    sx={{
        minWidth: 120,
        borderRadius: 2,
        fontWeight: "bold",
        textTransform: "none"
    }}
>
    Cancel
</Button>

<Button
    variant="contained"
    color="primary"
    onClick={handleSaveRollParent}
    disabled={savingRollParent}
    sx={{
        minWidth: 180,
        borderRadius: 2,
        fontWeight: "bold",
        textTransform: "none"
    }}
>

{savingRollParent ? (
<>
<CircularProgress
    size={22}
    color="inherit"
    sx={{ mr: 1 }}
/>
Saving...
</>
) : (
"Save All"
)}

</Button>

</Box>

</DialogActions>

</Dialog>

<Snackbar
    open={snack.open}
    autoHideDuration={3000}
    onClose={() =>
        setSnack({
            ...snack,
            open: false
        })
    }
    anchorOrigin={{
        vertical: "top",
        horizontal: "right"
    }}
>

<Alert
    severity={snack.severity}
    variant="filled"
    sx={{
        width: "100%"
    }}
    onClose={() =>
        setSnack({
            ...snack,
            open: false
        })
    }
>

{snack.message}

</Alert>

</Snackbar>



          {selectedStudents.length > 0 && (
  <>
    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        select
        label="Select Category"
        value={selectedCategory}
        onChange={(e) => handleCategoryChange(e.target.value)}
      >
        <MenuItem value="">-- Select Category --</MenuItem>
        {feesCategories.map((cat) => (
          <MenuItem key={cat.CategoryID} value={cat.CategoryID}>
            {cat.CategoryName}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
     {/* Conditionally Render Route Dropdown */}
  {routes.length > 0 && (
    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        select
        label="Select Route Fee"
        value={selectedRoute}
        onChange={(e) => setSelectedRoute(e.target.value)}
      >
        <MenuItem value="">-- Select Fee --</MenuItem>
        {routes.map((route) => (
          <MenuItem key={route.RouteID} value={route.RouteID}>
            ₹ {route.Fee} - {route.RouteName}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  )}


    <Grid item xs={12} sm={6}>
      <Button
        variant="contained"
        color="secondary"
        fullWidth
        disabled={!selectedCategory}
        onClick={handleUpdateCategory}
      >
        Update
      </Button>
    </Grid>
     <Grid item xs={12} sm={6}>
     <Button
    variant="contained"
    color="error"
    sx={{ mt: 2 }}
    onClick={handleDeleteStudents}
  >
    Delete Selected Students
  </Button>
  </Grid>
  </>
)}
        </Grid>
      </Card>
      {/* Students Table */}
      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976D2" }}>
            <TableRow>
              <TableCell padding="checkbox">
  <input
    type="checkbox"
    checked={
      students.length > 0 &&
      selectedStudents.length === students.length
    }
    onChange={handleSelectAll}
  />
</TableCell>
              <TableCell sx={{ color: "white" }}>Student ID</TableCell>
               <TableCell sx={{ color: "white" }}>Roll No</TableCell>
              <TableCell sx={{ color: "white" }}>Student Name</TableCell>
              <TableCell sx={{ color: "white" }}>Parent Name</TableCell>
              <TableCell sx={{ color: "white" }}>Mobile</TableCell>
              <TableCell sx={{ color: "white" }}>Course</TableCell>
              {/* <TableCell sx={{ color: "white" }}>Academic Year</TableCell> */}
              <TableCell sx={{ color: "white" }}>Class</TableCell>
               <TableCell sx={{ color: "white" }}>Section</TableCell>
              <TableCell sx={{ color: "white" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {students.length > 0 ? (
              students
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((student) => (
                  <TableRow key={student.StudentID}>
                    <TableCell padding="checkbox">
    <input
      type="checkbox"
      checked={selectedStudents.includes(student.StudentID)}
      onChange={() => handleSelectStudent(student.StudentID)}
    />
  </TableCell>
                    <TableCell>{student.StudentID}</TableCell>
                     <TableCell>{student.RollNumber}</TableCell>
                    <TableCell>{student.StudentName}</TableCell>
                    <TableCell>{student.ParentName}</TableCell>
                    <TableCell>{student.MobileNumber}</TableCell>
                    <TableCell>{student.CourseName}</TableCell>
                    {/* <TableCell>{student.AcademicYearName}</TableCell> */}
                    <TableCell>{student.ClassName}</TableCell>
                     <TableCell>{student.SectionName}</TableCell>
                    <TableCell>
                      <Tooltip title="Edit">
                        <IconButton
                          color="warning"
                          onClick={() => handleEdit(student.StudentID)}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={student.IsActive ? "Mark as Inactive" : "Mark as Active"}
                      >
                        <IconButton
                          color={student.IsActive ? "success" : "error"}
                          onClick={() => handleToggleStatus(student.StudentID, student.IsActive)}
                        >
                          {student.IsActive ? <CheckCircleIcon /> : <BlockIcon />}
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No students found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
         /*  rowsPerPageOptions={[5, 10, 25]} */
         rowsPerPageOptions={[50, 60, 80]}
          component="div"
          count={students.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </TableContainer>
    </Container>
  );
};
export default StudentsPage;
